import { render, staticRenderFns } from "./lottry.vue?vue&type=template&id=5a529795&"
import script from "./lottry.vue?vue&type=script&lang=js&"
export * from "./lottry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports